import FooterBottom from './FooterBottom';
import "./footer.scss";

export default function Footer() {
	return (
		<footer className="footer">
			<FooterBottom />
		</footer>
	)
}